import { render, staticRenderFns } from "./CreateCustomerProjectBriefPopUp.vue?vue&type=template&id=0330f530&scoped=true&"
import script from "./CreateCustomerProjectBriefPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerProjectBriefPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomerProjectBriefPopUp.vue?vue&type=style&index=0&id=0330f530&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0330f530",
  null
  
)

export default component.exports